import React, { FC } from "react";

type IProps = {
  isLiked?: boolean;
};

const LikePlayer: FC<IProps> = ({ isLiked }) => {
  return (
    <svg
      width="20"
      height="18"
      viewBox="0 0 20 18"
      fill={isLiked ? "#FD8533" : "none"}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M11.3975 2.58595L11.3979 2.58554C13.0803 0.849581 15.7426 0.6213 17.4911 2.1113C19.5541 3.87262 19.6658 7.04556 17.813 8.95751L17.8129 8.95769L10.2544 16.7622C10.11 16.9113 9.88632 16.9113 9.74184 16.7624C9.74178 16.7623 9.74173 16.7623 9.74167 16.7622L2.18361 8.95807C0.334054 7.04599 0.445829 3.87242 2.50922 2.11108C4.25801 0.621031 6.92363 0.850176 8.60154 2.58491L8.60255 2.58595L9.37208 3.37892L10 4.02597L10.6279 3.37892L11.3975 2.58595Z"
        stroke={isLiked ? "#FD8533" : "#8C8C8C"}
        stroke-width="1.75"
      />
    </svg>
  );
};

export default LikePlayer;
